import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import PropertyByAgent from "../components/proeprtybyagent";
import CTA from "../components/cta";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
function AgentDetailsDemo() {
  const { id } = useParams();
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    agent_name: "",
    agent_phone: "",
    agent_email: "",
    agent_address: ""
  });
  const [errors, setErrors] = useState({});
  const [responseMsg, setResponseMsg] = useState("");
  const [responseType, setResponseType] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const nextErrors = {};

    if (!formData.agent_name.trim()) {
      nextErrors.agent_name = "Name is required";
    }

    if (!formData.agent_phone.trim()) {
      nextErrors.agent_phone = "Phone number is required";
    } else if (!/^[0-9+\s-]{7,15}$/.test(formData.agent_phone)) {
      nextErrors.agent_phone = "Invalid phone number";
    }

    if (!formData.agent_email) {
      nextErrors.agent_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
      nextErrors.agent_email = "Invalid email address";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((currentFormData) => ({
      ...currentFormData,
      [name]: value
    }));
    setErrors((currentErrors) => ({
      ...currentErrors,
      [name]: ""
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResponseMsg("");

    if (!validate()) return;

    setSubmitting(true);

    try {
      const payload = {
        proref: property.fullname,
        pid: property.id,
        current_url: window.location.href,
        ...formData,
        enqtyp: "Request a Viewing"
      };

      const res = await axios.post(
        `${API}/api/EnquiryHandleragent.ashx`,
        JSON.stringify(payload),
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      setResponseType("success");
      setResponseMsg(res.data?.message || "Message sent successfully!");
      setFormData({
        agent_name: "",
        agent_phone: "",
        agent_email: "",
        agent_address: ""
      });
      setErrors({});
    } catch (error) {
      console.error("Error submitting agent enquiry:", error);
      setResponseType("error");
      setResponseMsg("Something went wrong!");
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        setLoading(true);

        const res = await axios.post(`${API}/api/agentdetails.ashx`,
          { id: id },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setProperty(res.data.data?.[0] || null);
      } catch (error) {
        console.error("Error fetching blog:", error);
        setProperty(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProperty();
  }, [API, id]);

  // ✅ Loading state
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        Loading...
      </div>
    );
  }

  // ✅ Empty state
  if (!property) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        Agent not found
      </div>
    );
  }

  return (
    <>
      {/* Banner */}
       <style
    dangerouslySetInnerHTML={{
      __html:
        '\n\n\n            .agent-page-wrap {\n                width: 100%;\n                padding: 18px 24px;\n                margin-top: 100px;\n            }\n\n            .agent-page-main {\n                width: 100%;\n                margin: 0 auto;\n            }\n\n            /* HERO */\n\n            .agent-hero {\n                background: #fff;\n                border: 1px solid #e4e8ee;\n                border-radius: 28px;\n                box-shadow: 0 12px 38px rgba(9, 31, 66, 0.06);\n                min-height: auto;\n                display: grid;\n                grid-template-columns: 280px 1fr 365px;\n                overflow: hidden;\n                padding: 8px;\n            }\n\n            .agent-photo-area {\n                position: relative;\n            }\n\n\n\n                .agent-photo-area img {\n                    border-radius: 25px;\n                    position: relative;\n                    z-index: 2;\n                }\n\n            .agent-hero-info {\n                padding: 20px 0 0 20px;\n                display: flex;\n                flex-direction: column;\n            }\n\n            .agent-title-name {\n                font-size: 40px;\n                line-height: 1;\n                color: #293e95;\n                font-weight: 700;\n                margin-bottom: 16px;\n            }\n\n            .agent-title-role {\n                color: #293e95;\n                font-size: 16px;\n                text-transform: uppercase;\n                letter-spacing: 4px;\n                font-weight: 700;\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                margin-bottom: 10px;\n            }\n\n                .agent-title-role::after {\n                    content: "";\n                    width: 58px;\n                    height: 2px;\n                    background: #293e95;\n                }\n\n            .agent-active-row {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                color: #071f49;\n                font-size: 20px;\n                font-weight: 600;\n                margin-bottom: 10px;\n            }\n\n            .agent-mini-icon {\n                width: 38px;\n                height: 38px;\n                border-radius: 12px;\n                background: #f2f5f9;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: #071f49;\n            }\n\n            .agent-para {\n                color: #5f6c80;\n                font-size: 14px;\n                line-height: 1.65;\n                margin-bottom: 10px;\n            }\n\n            .agent-badge-row {\n                display: flex;\n                gap: 18px;\n                flex-wrap: wrap;\n                margin-bottom: 28px;\n            }\n\n            .agent-badge {\n                height: 40px;\n                padding: 0 15px;\n                border-radius: 12px;\n                background: linear-gradient(180deg, #f5f7fa, #ffffff);\n                border: 1px solid #eef1f4;\n                box-shadow: 0 8px 18px rgba(10, 31, 66, 0.04);\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 5px;\n                color: #071f49;\n                font-size: 14px;\n                font-weight: normal;\n            }\n\n                .agent-badge.dark {\n                    background: #062452;\n                    color: #fff;\n                    border-color: #062452;\n                }\n\n                .agent-badge svg {\n                    color: #d99817;\n                }\n\n                .agent-badge:nth-child(2) svg {\n                    color: #0d5f93;\n                }\n\n            .agent-stats {\n                width: 100%;\n                max-width: 1180px;\n                border: 1px solid #e7ebf0;\n                border-radius: 15px;\n                display: grid;\n                grid-template-columns: repeat(4, 1fr);\n                overflow: hidden;\n                background: #fff;\n                box-shadow: 0 10px 30px rgba(10, 31, 66, 0.04);\n            }\n\n            .agent-stat-item {\n                min-height: 95px;\n                padding: 22px 28px;\n                display: flex;\n                align-items: center;\n                gap: 18px;\n                border-right: 1px solid #e7ebf0;\n            }\n\n                .agent-stat-item:last-child {\n                    border-right: none;\n                }\n\n            .agent-stat-icon {\n                width: 58px;\n                height: 58px;\n                border-radius: 50%;\n                background: #fbf2e6;\n                color: #d99817;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                flex-shrink: 0;\n            }\n\n            .agent-stat-text span {\n                display: block;\n                color: #7a8494;\n                font-size: 14px;\n                font-weight: 600;\n            }\n\n            .agent-stat-text strong {\n                display: block;\n                color: #071f49;\n                font-size: 16px;\n                font-weight: 800;\n                margin-top: 2px;\n            }\n\n            /* RIGHT BUTTONS */\n\n            .agent-action-area {\n                border-left: 1px solid #dde3ea;\n                padding: 0 30px;\n                display: flex;\n                position: relative;\n            }\n\n            .agent-action-logo {\n                position: absolute;\n                top: -20px;\n                right: 36px;\n                color: #d99817;\n            }\n\n            .agent-action-box {\n                width: 100%;\n                max-width: 310px;\n            }\n\n            .agent-action-btn {\n                height: 56px;\n                width: 100%;\n                border-radius: 12px;\n                margin-bottom: 14px;\n                background: #fff;\n                border: 1px solid #dce2ea;\n                box-shadow: 0 10px 24px rgba(9, 31, 66, 0.08);\n                text-decoration: none;\n                color: #071f49;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                padding: 0 20px;\n                font-size: 16px;\n                font-weight: 700;\n            }\n\n                .agent-action-btn span {\n                    display: flex;\n                    align-items: center;\n                    gap: 14px;\n                }\n\n                .agent-action-btn:first-child {\n                    background: #293e95;\n                    color: #fff;\n                    border-color: #293e95;\n                }\n\n                .agent-action-btn.gold {\n                    background: #293e95;\n                    color: #fff;\n                    border-color: #293e95;\n                }\n\n            /* ABOUT STRIP */\n\n            .agent-about-strip {\n                background: #fff;\n                border: 1px solid #e5e9ef;\n                border-radius: 22px;\n                min-height: 118px;\n                margin-top: 14px;\n                padding: 24px 42px;\n                display: grid;\n                grid-template-columns: 76px 1fr 0px;\n                align-items: center;\n                gap: 28px;\n                box-shadow: 0 10px 28px rgba(9, 31, 66, 0.05);\n                overflow: hidden;\n            }\n\n            .agent-round-icon {\n                width: 62px;\n                height: 62px;\n                border-radius: 50%;\n                background: #293e95;\n                color: #fff;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n\n            .agent-about-content {\n                border-left: 1px solid #dde3ea;\n                padding-left: 36px;\n            }\n\n                .agent-about-content h2 {\n                    color: #071f49;\n                    font-size: 26px;\n                    margin-bottom: 8px;\n                }\n\n                .agent-about-content p {\n                    color: #637084;\n                    font-size: 14px;\n                    line-height: 1.55;\n                }\n\n            .agent-line-building {\n                justify-self: end;\n                color: #d99817;\n                opacity: 0.35;\n            }\n\n            /* BOTTOM */\n\n            .agent-bottom-grid {\n                margin-top: 14px;\n                display: grid;\n                grid-template-columns: 1.65fr 0.9fr;\n                gap: 18px;\n            }\n\n            .agent-profile-box {\n                background: #fff;\n                border: 1px solid #e5e9ef;\n                border-radius: 24px;\n                padding: 20px;\n                box-shadow: 0 12px 38px rgba(9, 31, 66, 0.06);\n            }\n\n            .agent-section-heading {\n                display: inline-block;\n                font-size: 30px;\n                color: #071f49;\n                margin-bottom: 34px;\n                position: relative;\n            }\n\n                .agent-section-heading::after {\n                    content: "";\n                    width: 58px;\n                    height: 2px;\n                    background: #d99817;\n                    position: absolute;\n                    left: 0;\n                    bottom: -10px;\n                }\n\n            .agent-info-grid {\n                display: grid;\n                grid-template-columns: 1fr 1.12fr;\n                gap: 20px;\n            }\n\n            .agent-info-grid-bottom {\n                grid-column: 1 / -1;\n                display: grid;\n                grid-template-columns: 1fr 0.95fr 0.9fr;\n                gap: 20px;\n            }\n\n            .agent-info-card {\n                min-height: 120px;\n                background: #fff;\n                border: 1px solid #e8ebf0;\n                border-radius: 16px;\n                box-shadow: 0 10px 28px rgba(9, 31, 66, 0.06);\n                padding: 16px 16px;\n                display: flex;\n                align-items: center;\n                gap: 15px;\n            }\n\n            .agent-info-card-icon {\n                width: 66px;\n                height: 66px;\n                border-radius: 50%;\n                background: #fff;\n                border: 1px solid #293e95;\n                color: #293e95;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                flex-shrink: 0;\n            }\n\n            .agent-info-text small {\n                display: block;\n                text-transform: uppercase;\n                color: #071f49;\n                font-size: 12px;\n                font-weight: normal;\n                margin-bottom: 0px;\n            }\n\n            .agent-info-text strong {\n                font-size: 16px;\n                font-weight: 600;\n                color: #1b2940;\n            }\n\n            /* CONTACT CARD */\n\n            .agent-contact-box {\n                background: #293e95;\n                border-radius: 24px;\n                padding: 36px 54px;\n                color: #fff;\n                box-shadow: 0 12px 38px rgba(9, 31, 66, 0.12);\n                position: relative;\n                overflow: hidden;\n            }\n\n                .agent-contact-box::after {\n                    content: "";\n                    position: absolute;\n                    right: -40px;\n                    bottom: -30px;\n                    width: 260px;\n                    height: 260px;\n                    border: 1px solid rgba(255,255,255,0.06);\n                    transform: rotate(45deg);\n                    border-radius: 22px;\n                }\n\n                .agent-contact-box h3 {\n                    color: #fff;\n                    font-size: 30px;\n                    margin-bottom: 8px;\n                    position: relative;\n                    z-index: 2;\n                }\n\n            .agent-contact-line {\n                width: 50px;\n                height: 2px;\n                background: #fff;\n                margin-bottom: 12px;\n                position: relative;\n                z-index: 2;\n            }\n\n            .agent-contact-box p {\n                color: rgba(255,255,255,0.88);\n                font-size: 15px;\n                line-height: 1.5;\n                margin-bottom: 10px;\n                position: relative;\n                z-index: 2;\n            }\n\n            .agent-contact-item {\n                display: flex;\n                align-items: flex-start;\n                gap: 10px;\n                padding: 10px 0;\n                border-bottom: 1px solid rgba(255,255,255,0.16);\n                position: relative;\n                z-index: 2;\n            }\n\n                .agent-contact-item:last-child {\n                    border-bottom: none;\n                }\n\n            .agent-contact-icon {\n                width: 48px;\n                height: 48px;\n                border-radius: 50%;\n                border: 1px solid #fff;\n                color: #fff;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                flex-shrink: 0;\n            }\n\n            .agent-contact-item a,\n            .agent-contact-item span {\n                color: #fff;\n                font-size: 16px;\n                font-weight: normal;\n                text-decoration: none;\n                line-height: 1.55;\n            }\n\n            svg {\n                width: 22px;\n                height: 22px;\n            }\n\n            /* RESPONSIVE */\n\n            @media (max-width: 1400px) {\n                .agent-hero {\n                    grid-template-columns: 287px 1fr 276px;\n                }\n\n                .agent-title-name {\n                    font-size: 30px;\n                }\n\n                .agent-stats {\n                    grid-template-columns: repeat(2, 1fr);\n                }\n\n                .agent-stat-item:nth-child(2) {\n                    border-right: none;\n                }\n\n                .agent-stat-item:nth-child(1),\n                .agent-stat-item:nth-child(2) {\n                    border-bottom: 1px solid #e7ebf0;\n                }\n            }\n\n            @media (max-width: 1200px) {\n                .agent-hero {\n                    grid-template-columns: 330px 1fr;\n                }\n\n                .agent-action-area {\n                    grid-column: 1 / -1;\n                    border-left: none;\n                    border-top: 1px solid #dde3ea;\n                    margin: 0;\n                    padding: 12px;\n                }\n\n                .agent-action-logo {\n                    display: none;\n                }\n\n                .agent-action-box {\n                    max-width: 100%;\n                    display: grid;\n                    grid-template-columns: repeat(4, 1fr);\n                    gap: 10px;\n                }\n\n                .agent-action-btn {\n                    margin-bottom: 0;\n                }\n\n                .agent-bottom-grid {\n                    grid-template-columns: 1fr;\n                }\n            }\n\n            @media (max-width: 991px) {\n                .agent-page-wrap {\n                    padding: 14px;\n                }\n\n                .agent-hero {\n                    grid-template-columns: 1fr;\n                }\n\n                .agent-photo-area {\n                    min-height: 460px;\n                }\n\n                .agent-hero-info {\n                    padding: 10px;\n                }\n\n                .agent-action-box {\n                    grid-template-columns: repeat(2, 1fr);\n                }\n\n                .agent-about-strip {\n                    grid-template-columns: 70px 1fr;\n                    padding: 24px;\n                }\n\n                .agent-line-building {\n                    display: none;\n                }\n\n                .agent-info-grid,\n                .agent-info-grid-bottom {\n                    grid-template-columns: 1fr;\n                }\n            }\n\n            @media (max-width: 767px) {\n\n                .agent-info-card {\n                    min-height: 60px;\n                    background: #fff;\n                    border: 1px solid #e8ebf0;\n                    border-radius: 16px;\n                    box-shadow: 0 10px 28px rgba(9, 31, 66, 0.06);\n                    padding: 16px 16px;\n                    display: flex;\n                    align-items: center;\n                    gap: 15px;\n                }\n\n                .agent-title-role {\n                    color: #d99817;\n                    font-size: 17px;\n                    text-transform: uppercase;\n                    letter-spacing: 4px;\n                    font-weight: 700;\n                    display: flex;\n                    align-items: center;\n                    gap: 10px;\n                    margin-bottom: 10px;\n                }\n\n                .agent-page-wrap {\n                    padding: 10px;\n                }\n\n                .agent-hero,\n                .agent-profile-box,\n                .agent-contact-box,\n                .agent-about-strip {\n                    border-radius: 18px;\n                }\n\n                .agent-photo-area {\n                    min-height: 370px;\n                    border-radius: 16px;\n                }\n\n                .agent-title-name {\n                    font-size: 36px;\n                }\n\n                .agent-title-role {\n                    font-size: 12px;\n                    letter-spacing: 1.5px;\n                }\n\n                .agent-para {\n                    font-size: 14px;\n                }\n\n                .agent-badge {\n                    width: 100%;\n                    min-width: 100%;\n                }\n\n                .agent-stats {\n                    grid-template-columns: 1fr;\n                }\n\n                .agent-stat-item {\n                    border-right: none;\n                    border-bottom: 1px solid #e7ebf0;\n                }\n\n                    .agent-stat-item:last-child {\n                        border-bottom: none;\n                    }\n\n                .agent-action-box {\n                    grid-template-columns: 1fr;\n                }\n\n                .agent-about-strip {\n                    grid-template-columns: 1fr;\n                }\n\n                .agent-about-content {\n                    border-left: none;\n                    padding-left: 0;\n                }\n\n                .agent-profile-box,\n                .agent-contact-box {\n                    padding: 15px 10px;\n                }\n\n                .agent-info-card {\n                    padding: 10px;\n                    gap: 10px;\n                }\n\n                .agent-info-card-icon {\n                    width: 58px;\n                    height: 58px;\n                }\n            }\n\n            @media (max-width: 480px) {\n                .agent-photo-area {\n                    min-height: 310px;\n                }\n\n                .agent-title-name {\n                    font-size: 31px;\n                }\n\n                .agent-active-row {\n                    font-size: 16px;\n                }\n\n                .agent-section-heading,\n                .agent-contact-box h3,\n                .agent-about-content h2 {\n                    font-size: 25px;\n                }\n\n                .agent-contact-item a,\n                .agent-contact-item span {\n                    font-size: 14px;\n                }\n            }\n        '
    }}
  />
  <section className="agent-page-wrap">
    <div className="container">
      <div className="agent-page-main">
        <div className="agent-hero">
          <div className="agent-photo-area">
            {/* replace this image with your real agent image */}
            <img src={property.ImagePath+"/w=800,sharpen=1"} alt={property.fullname} />
          </div>
          <div className="agent-hero-info">
            <h1 className="agent-title-name">{property.fullname}</h1>
            <div className="agent-title-role">{property.designation}</div>
            <div className="agent-active-row">
              <span className="agent-mini-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M3 11L12 4l9 7" />
                  <path d="M5 10v10h14V10" />
                  <path d="M9 20v-6h6v6" />
                </svg>
              </span>
              
              {property.numberofproperty} Active Properties
            </div>
            <div
              className="social-wrapper"
              style={{ marginTop: 5, textAlign: "left" }}
            >
              <div className="social-links" style={{ justifyContent: "left" }}>
                <a
                  href="https://www.instagram.com/nvrealestate_uae"
                  target="_blank"
                  className="instagram"
                >
                  <i className="fab fa-instagram" />
                </a>
                <a
                  href="https://www.facebook.com/nvrealestate.uae"
                  target="_blank"
                  className="facebook"
                >
                  <i className="fab fa-facebook-f" />
                </a>
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  className="linkedin"
                >
                  <i className="fab fa-linkedin-in" />
                </a>
              </div>
            </div>
          </div>
          <div className="agent-action-area">
            <div className="agent-action-box">
              <a href={"tel:"+property.mobile} className="agent-action-btn">
                <span>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M22 16.9v3a2 2 0 0 1-2.2 2A19.7 19.7 0 0 1 3 5.2 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.7c.1.9.3 1.7.6 2.5a2 2 0 0 1-.4 2.1L9 10.5a16 16 0 0 0 4.5 4.5l1.2-1.2a2 2 0 0 1 2.1-.4c.8.3 1.6.5 2.5.6A2 2 0 0 1 22 16.9z" />
                  </svg>
                  Call
                </span>
                ›
              </a>
              <a href={`https://wa.me/${property.whatsapp}`} className="agent-action-btn">
                <span>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M20 11.5a8 8 0 0 1-11.8 7L4 20l1.5-4.1A8 8 0 1 1 20 11.5z" />
                  </svg>
                  WhatsApp
                </span>
                ›
              </a>
              <a
                href={"mailto:"+property.email}
                className="agent-action-btn"
              >
                <span>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M4 6h16v12H4z" />
                    <path d="M4 7l8 6 8-6" />
                  </svg>
                  Email
                </span>
                ›
              </a>
              <a data-bs-toggle="modal"
          data-bs-target="#demoModal" className="agent-action-btn gold">
                <span>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M4 5h16v16H4z" />
                    <path d="M8 3v4M16 3v4M4 10h16" />
                  </svg>
                  Book a Viewing
                </span>
                ›
              </a>
            </div>
          </div>
        </div>
        <div className="agent-about-strip">
          <div className="agent-round-icon">
            <svg
              viewBox="0 0 24 24"
              fill="#fff"
              stroke="currentColor"
              strokeWidth="1.8"
            >
              <circle cx={12} cy={7} r={4} />
              <path d="M5 21v-2a7 7 0 0 1 14 0v2" />
            </svg>
          </div>
          <div className="agent-about-content">
            <h2>About {property.fullname}</h2>
           <div id="aboutagent"
                  dangerouslySetInnerHTML={{
                    __html: property.Description,
                  }}
                />
          </div>
          <div className="agent-line-building">
            <svg
              viewBox="0 0 150 80"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
            >
              <path d="M8 68h134" />
              <path d="M28 68V35l34-16 34 16v33" />
              <path d="M62 68V19" />
              <path d="M96 68V35" />
              <path d="M42 68V48h15v20" />
              <path d="M72 68V43h15v25" />
              <path d="M108 68V30l20 10v28" />
            </svg>
          </div>
        </div>
        <div className="agent-bottom-grid">
          <div className="agent-profile-box">
            <h2 className="agent-section-heading">Agent Profile</h2>
            <div className="agent-info-grid">
              <div className="agent-info-card">
                <div className="agent-info-card-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <circle cx={12} cy={7} r={4} />
                    <path d="M5 21v-2a7 7 0 0 1 14 0v2" />
                  </svg>
                </div>
                <div className="agent-info-text">
                  <small>Role</small>
                  <strong>{property.designation}</strong>
                </div>
              </div>
              <div className="agent-info-card">
                <div className="agent-info-card-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M12 21s7-5.2 7-12a7 7 0 0 0-14 0c0 6.8 7 12 7 12z" />
                    <circle cx={12} cy={9} r="2.5" />
                  </svg>
                </div>
                <div className="agent-info-text">
                  <small>Specialized In</small>
                  <strong>{property.SpecializedAreas}</strong>
                </div>
              </div>
              <div className="agent-info-card">
                <div className="agent-info-card-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
                    <path d="M8 10h.01M12 10h.01M16 10h.01" />
                  </svg>
                </div>
                <div className="agent-info-text">
                  <small>Languages Spoken</small>
                  <strong>{property.Languages}</strong>
                </div>
              </div>
              <div className="agent-info-card">
                <div className="agent-info-card-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M3 11L12 4l9 7" />
                    <path d="M5 10v10h14V10" />
                    <path d="M9 20v-6h6v6" />
                  </svg>
                </div>
                <div className="agent-info-text">
                  <small>Listings</small>
                  <strong>{
  property.numberofproperty > 0
    ? `${property.numberofproperty} Active Properties`
    : "Property Not Available This Time"
} </strong>
                </div>
              </div>
            </div>
          </div>
          <div className="agent-contact-box">
            <h3>Contact Details</h3>
            <div className="agent-contact-line" />
            <p>
              Connect directly for property inquiries, viewings, and expert
              guidance.
            </p>
            <div className="agent-contact-item">
              <div className="agent-contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2A19.7 19.7 0 0 1 3 5.2 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.7c.1.9.3 1.7.6 2.5a2 2 0 0 1-.4 2.1L9 10.5a16 16 0 0 0 4.5 4.5l1.2-1.2a2 2 0 0 1 2.1-.4c.8.3 1.6.5 2.5.6A2 2 0 0 1 22 16.9z" />
                </svg>
              </div>
              <a href="tel:+971501577822">+971 50 157 7822</a>
            </div>
            <div className="agent-contact-item">
              <div className="agent-contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M4 6h16v12H4z" />
                  <path d="M4 7l8 6 8-6" />
                </svg>
              </div>
              <a href="mailto:alberto@nvrealestate.ae">
                alberto@nvrealestate.ae
              </a>
            </div>
            <div className="agent-contact-item">
              <div className="agent-contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                >
                  <path d="M12 21s7-5.2 7-12a7 7 0 0 0-14 0c0 6.8 7 12 7 12z" />
                  <circle cx={12} cy={9} r="2.5" />
                </svg>
              </div>
              <span>
                Sama Tower – Office 406 Zayed The First St Al Danah – Zone 1 –
                Abu Dhabi – UAE
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="contact-section" > 
       <section className="flat-section flat-recommended">
    <div className="container">
    {property.numberofproperty > 0 && (
  <div className="box-title style-1 wow fadeInUp">
    <h3 className="title mt-4">Active Listings</h3>

    <p className="section-text mb-20">
      A quick look at some of the premium properties currently
      represented by {property.fullname}.
    </p>
  </div>
)}
    <PropertyByAgent offertype={property.id} typ="Home" />
    </div>
  </section> 
  </section>
  <div
    className="modal fade"
    id="demoModal"
    tabIndex={-1}
    aria-labelledby="demoModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content text-center p-3">
        <div className="modal-header">
          <h5 className="modal-title w-100" id="demoModalLabel">
            Book a Viewing
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <form  className="contact-form" onSubmit={handleSubmit}>
                <input
                  type="hidden"
                  name="proref"
                  id="proref"
                  className="input"
                  defaultValue={property.fullname}
                  style={{ width: "100%" }}
                />
                <input
  type="hidden"
  name="enqtyp"
  value="Request a Viewing"
/> 
                
                <div className="ip-group">
                  <input
                    type="text"
                    name="agent_name"
                    id="agent_name"
                    value=""
                    onChange={handleChange}
                    placeholder="Name"
                    className={`form-control ${errors.agent_name ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_name && (
    <p className="error-text">{errors.agent_name}</p>
  )}
                </div>
                <div className="ip-group">
                 <PhoneInput
  country={"ae"}   // default UAE 🇦🇪
  value={formData.agent_phone}
  onChange={(phone) =>
    setFormData({ ...formData, agent_phone: phone })
  }
  inputClass="form-control phone-input"
  containerClass="phone-container"
  enableSearch={true}
  placeholder="Enter phone number"
/>
                   {errors.agent_phone && (
    <p className="error-text">{errors.agent_phone}</p>
  )}
                </div>
                <div className="ip-group">
                  <input
                    type="email"
                    name="agent_email"
                    id="agent_email"
                    value={formData.agent_email}
                    onChange={handleChange}
                    placeholder="Email"
                    className={`form-control ${errors.agent_email ? "input-error" : ""}`}
                    required=""
                  />
                   {errors.agent_email && (
    <p className="error-text">{errors.agent_email}</p>
  )}
                </div>
                <div className="ip-group">
                 <textarea
  name="agent_address"
  id="agent_address"
  rows={4}
  placeholder="Message"
  value={formData.agent_address}
  onChange={handleChange}
  className="form-control"
  required
/>
                  <p className="error">{errors.agent_address}</p>
                </div>
                <div className="ip-group">
                {responseMsg && (
  <div className={`alert-box ${responseType}`}>
    {responseMsg}
  </div>
)}
                </div>
                <button
  type="submit"
  className="tf-btn-1 btn-view primary hover-btn-view w-100"
  disabled={submitting}
>
  {submitting ? "Sending..." : "Submit"}
  <span className="icon icon-arrow-right2" />
</button>
              </form>
      </div>
    </div>
  </div>
  <CTA/>
    </>
  );
}

export default AgentDetailsDemo;
